import React, { useContext, useState, useEffect, useRef } from "react";
import { GrUserAdmin } from "react-icons/gr";
import {
  RiAdminLine,
  RiFeedbackLine,
  RiLightbulbFlashLine,
} from "react-icons/ri";
import { MdAddReaction } from "react-icons/md";
import styled from "styled-components";
import { UserContext } from "../../../contexts/UserContext";
import DetailsGeneral from "./DetailsGeneral";

//#region styles
const Layout = styled.div`
  display: flex;
  width: 85vw;
  flex-direction: column;
  height: auto;
  font-size: 0.6em;
  border-radius: 1rem;
  background-color: rgba(255, 255, 255, 0.13);
  backdrop-filter: blur(10px);
  padding: 2rem 1rem;
  box-shadow: var(--shadow-main);
`;
const TabContainer = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;

  padding: 0.5em;

  border-radius: 1rem;
  background-color: var(--color-silver-100); // Example background color
  box-shadow: var(--shadow-btn);
`;

const Tab = styled.button`
  padding: 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
`;
// Add more styles for the tabs
const ContentArea = styled.div`
  padding: 1.5em;
  flex-grow: 1;
`;

const TabIcon = styled.span`
  background: none;
  border: none;
  margin-right: 0.4em;
  border-radius: var(--border-radius-sm);
  transition: all 0.2s;

  &:hover {
    color: var(--color-grey-100);
  }
`;

//#endregion

// Define the component
const ActiveFaultsDetailsTabFormComponent = ({ fault }) => {
  const initialFaultRef = useRef(fault); // Store the initial fault value

  const [activeTab, setActiveTab] = useState("manageGeneral");

  const { userDetails } = useContext(UserContext);
  const {
    userEmail,
    userToken,
    userName,
    userCompany,
    userAccessLevel,
    userImage,
    userWiMuleToken,
    userWiMuleTokenTimestamp,
  } = userDetails || {}; // Destructure from userDetails and provide a fallback

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    console.log("User Details", userDetails);
  }, [userDetails]);

  const isAdmin = userAccessLevel === "Admin";

  return (
    <Layout>
      <ContentArea>
        {activeTab === "manageGeneral" && (
          <DetailsGeneral fault={initialFaultRef.current} />
        )}

        {activeTab === "solutions" && (
          <div>
            <h2>Add/Edit Suggested solutions</h2>
          </div>
        )}
        {activeTab === "addTemporary" && (
          <div>
            <h2>Add Temporary</h2>
            <p>Remove fault for the next 4 hours</p>
          </div>
        )}
        {activeTab === "requestPermanent" && (
          <div>
            <h2>Request to admin to filter fault permanently</h2>
          </div>
        )}
        {/* Conditionally render content for other tabs */}
      </ContentArea>
      <TabContainer>
        <Tab onClick={() => setActiveTab("solutions")}>
          <TabIcon>
            <RiLightbulbFlashLine />
          </TabIcon>
          Solutions
        </Tab>
        <Tab onClick={() => setActiveTab("requestPermanent")}>
          <TabIcon>
            <RiFeedbackLine />
          </TabIcon>
          Request Filter
        </Tab>
        <Tab disabled={!isAdmin} onClick={() => setActiveTab("addTemporary")}>
          <TabIcon>{(isAdmin && <GrUserAdmin />) || <RiAdminLine />}</TabIcon>
          Add Temporary
        </Tab>
      </TabContainer>
    </Layout>
  );
};

// Memoize the component
const ActiveFaultsDetailsTabForm = React.memo(
  ActiveFaultsDetailsTabFormComponent
);

// Add a display name
ActiveFaultsDetailsTabForm.displayName = "ActiveFaultsDetailsTabForm";

export default ActiveFaultsDetailsTabForm;
